import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';
import { GUIDES } from '../../content/guides';

function Guides({ onBack, onOpenArticle, basePath = '' }) {
  const { t } = useTranslation();

  const prefix = basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;

  return (
    <div className="page-container">
      <h1>{t('guides_title')}</h1>
      <p>{t('guides_intro')}</p>

      <div className="page-card-list">
        {GUIDES.map((g) => (
          <article className="page-card" key={g.slug}>
            <h2 className="page-card-title">{t(g.titleKey)}</h2>
            <p className="page-card-excerpt">{t(g.excerptKey)}</p>
            <div className="page-card-actions">
              <a
                className="page-button"
                href={`${prefix}/guides/${g.slug}`}
                onClick={(e) => {
                  e.preventDefault();
                  onOpenArticle(g.slug);
                }}
              >
                {t('read_more')}
              </a>
            </div>
          </article>
        ))}
      </div>

      <button className="back-button" onClick={onBack}>
        {t('back_to_home')}
      </button>
    </div>
  );
}

export default Guides;
